import './style/styles.css';

const Font = ({ children }) => children || null;

export default Font;
